import type {GetRefundProcedureTherapiesParams} from 'domain/usecases/private/refund/request/get-procedure-therapies';
import {makeGetRefundProcedureTherapies} from 'main/factories/usecases/private/refund/request/get-procedure-therapies';

export const getRefundProcedureTherapies = async (params: GetRefundProcedureTherapiesParams) => {
	const data = await makeGetRefundProcedureTherapies().get({signal: params.signal});
	data.content.therapies = data.content.therapies.filter(
		therapy => !params.therapiesAlreadyRecorded?.includes(therapy.code),
	);
	return data.content.therapies;
};
